module.exports = __webpack_public_path__ + "static/media/overlay_img.0802b9fb.png";